import { Reference } from '@approvalmax/types';
import { atomWithReset } from 'jotai/utils';
import { domain } from 'modules/data';

export type NetSuiteBillFields = Omit<
    domain.NetSuiteVendorBillDetails,
    'expenseLines' | 'itemLines' | 'vendor' | 'department' | 'class' | 'location' | 'subsidiary'
> & {
    vendor: Reference & Partial<domain.NetSuiteVendor>;
};

export const netSuiteBillFieldValuesState = atomWithReset<Partial<NetSuiteBillFields>>({});
